import React, { lazy, Suspense } from 'react';
// Re-export routes so existing imports in other files don't break
export * from './routes/AppRoutes';

// Lazy load components so we don't load legacy code when using the new app
const LegacyApp = lazy(() => import('./legacy/LegacyApp'));
const NewApp = lazy(() => import('./NewApp'));

function App() {
  // Check if we are running in legacy mode
  const isLegacy = process.env.REACT_APP_LEGACY === 'true';

  return (

    <Suspense fallback={<div>Loading...</div>}>
      {isLegacy ? <LegacyApp /> : <NewApp />}
    </Suspense>
  );
}

export default App;
